import { useEffect, useState } from "react";
import { Menu, X } from "lucide-react";
import { scrollToId, startLenis, stopLenis } from "@/lib/smooth-scroll";
import { BrandLogo } from "@/components/site/BrandLogo";

const NAV_ITEMS = [
  { label: "Leistungen", target: "#leistungen", idx: 1 },
  { label: "Ansatz", target: "#ansatz", idx: 2 },
  { label: "Branchen", target: "#branchen", idx: 3 },
  { label: "Referenzen", target: "#referenzen", idx: 4 },
  { label: "Kontakt", target: "#kontakt", idx: 5 },
];

export const Navbar = ({ active }) => {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll, { passive: true });
    onScroll();
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => {
    if (menuOpen) {
      stopLenis();
      document.body.style.overflow = "hidden";
    } else {
      startLenis();
      document.body.style.overflow = "";
    }
    return () => {
      startLenis();
      document.body.style.overflow = "";
    };
  }, [menuOpen]);

  const go = (target) => {
    setMenuOpen(false);
    setTimeout(() => scrollToId(target), 120);
  };

  return (
    <>
      <nav className={`dl-nav ${scrolled ? "is-scrolled" : ""}`} data-testid="main-nav">
        <div className="mx-auto flex max-w-7xl items-center justify-between px-6 py-5 lg:px-10">
          <button
            onClick={() => scrollToId("#hero")}
            className="flex items-center bg-transparent border-none p-0"
            aria-label="DirektLab Startseite"
            data-testid="nav-brand"
          >
            <BrandLogo className="h-9 w-auto sm:h-11" />
          </button>
          <div className="hidden items-center gap-10 md:flex">
            {NAV_ITEMS.map((item) => (
              <button
                key={item.target}
                onClick={() => scrollToId(item.target)}
                className={`nav-link ${active === item.idx ? "is-active" : ""}`}
                data-testid={`nav-link-${item.label.toLowerCase()}`}
              >
                {item.label}
              </button>
            ))}
          </div>
          <button
            className="menu-toggle md:hidden"
            onClick={() => setMenuOpen(true)}
            aria-label="Menü öffnen"
            data-testid="nav-burger-button"
          >
            <Menu size={26} strokeWidth={1.8} />
          </button>
        </div>
      </nav>

      <div className={`mobile-menu ${menuOpen ? "is-open" : ""}`} data-testid="mobile-menu">
        <div className="flex items-center justify-between px-6 py-5">
          <BrandLogo className="h-9 w-auto" invert />
          <span className="sr-only">DirektLab</span>
          <button
            className="menu-toggle !text-[#F5F1E8]"
            onClick={() => setMenuOpen(false)}
            aria-label="Menü schließen"
            data-testid="mobile-menu-close"
          >
            <X size={28} strokeWidth={1.8} />
          </button>
        </div>
        <div className="flex flex-1 flex-col justify-center gap-1 px-8">
          {NAV_ITEMS.map((item, i) => (
            <button
              key={item.target}
              onClick={() => go(item.target)}
              className="mobile-menu-link"
              style={{ transitionDelay: menuOpen ? `${0.12 + i * 0.07}s` : "0s" }}
              data-testid={`mobile-menu-link-${item.label.toLowerCase()}`}
            >
              <span className="mobile-menu-num">00{item.idx + 1}</span>
              {item.label}
            </button>
          ))}
        </div>
        <div className="px-8 pb-12">
          <button
            onClick={() => go("#kontakt")}
            className="btn-primary w-full"
            data-testid="mobile-menu-cta"
          >
            Kostenloses Erstgespräch
          </button>
        </div>
      </div>
    </>
  );
};
